import { makeStyles, Typography } from "@material-ui/core";
import { ExpressFleetUpdate } from "@saleor/auditLogs/utils/expressFleetUtils";
import { LocationRateUpdate } from "@saleor/auditLogs/utils/locationRateUtils";
import { PriceRateUpdate } from "@saleor/auditLogs/utils/priceRateUtils";
import { parseNewValues } from "@saleor/auditLogs/utils/utils";
import moment from "moment";
import React from "react";

import { LogisticsActivityLogs_logisticsActivityLogs_edges_node } from "../../types/LogisticsActivityLogs";
import { ShippingZoneActivityLogs_shippingZoneActivityLogs_edges_node } from "../../types/ShippingZoneActivityLogs";
import ExpressFleetRateEventCard from "../ExpressFleetRateEventCard/ExpressFleetRateEventCard";
import LocationRateEventCard from "../LocationRateEventCard";
import PriceRateEventCard from "../PriceRateEventCard";

const useStyles = makeStyles(
  _ => ({
    container: {
      borderBottom: "1px dashed #CED3DD",
      margin: "20px 15px"
    },
    marginBottom20: {
      marginBottom: "20px"
    }
  }),
  { name: "RateEventItem" }
);

interface RateEventItemProps {
  type?: "PRICE" | "LOCATION" | "EXPRESS_FLEET";
  mallId?: string;
  filterBulkMallId?: string;
  date: string;
  eventsByDate: Array<
    | ShippingZoneActivityLogs_shippingZoneActivityLogs_edges_node
    | LogisticsActivityLogs_logisticsActivityLogs_edges_node
  >;
}

const RateEventItem: React.FC<RateEventItemProps> = props => {
  const { type, mallId, filterBulkMallId, date, eventsByDate } = props;
  const classes = useStyles(props);

  const dateValue = moment
    .utc(date)
    .local()
    .format("MMMM DD, YYYY");

  return (
    <div className={classes.container}>
      <Typography variant="h6" className={classes.marginBottom20}>
        {dateValue}
      </Typography>
      {eventsByDate &&
        eventsByDate.length > 0 &&
        eventsByDate.map((event, index) => {
          const parsedValues = parseNewValues(event.newValues, type);

          return (
            <React.Fragment key={`auditLogsEventItem-${index}-${event.id}`}>
              {type === "LOCATION" ? (
                <LocationRateEventCard
                  key={`auditLogsLocationEventItem-${index}-${event.id}`}
                  event={
                    event as ShippingZoneActivityLogs_shippingZoneActivityLogs_edges_node
                  }
                  eventNewValues={parsedValues as LocationRateUpdate}
                />
              ) : type === "PRICE" ? (
                <PriceRateEventCard
                  key={`auditLogsPriceEventItem-${index}-${event.id}`}
                  event={
                    event as ShippingZoneActivityLogs_shippingZoneActivityLogs_edges_node
                  }
                  eventNewValues={parsedValues as PriceRateUpdate}
                />
              ) : type === "EXPRESS_FLEET" ? (
                <ExpressFleetRateEventCard
                  key={`auditLogsExpressFleetEventItem-${index}-${event.id}`}
                  event={
                    event as LogisticsActivityLogs_logisticsActivityLogs_edges_node
                  }
                  eventNewValues={parsedValues as ExpressFleetUpdate}
                  mallId={mallId}
                  filterBulkMallId={filterBulkMallId}
                />
              ) : null}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default RateEventItem;
